import { isMediumScreen } from './utils';
export const paragraphScroller = () => {
    const letterButtons = document.querySelectorAll('.letter-button');
    let shouldExecuteScrollEvent = true;
    let lastIndex = false;
    let currentIndex = 0;
    let isScrolling;
    var userAgent = navigator.userAgent;
    let contentSection;
    const isElementInView = (elem) => {
        const scrollPosition = window.scrollY || window.pageYOffset;
        return (scrollPosition >= elem.offsetTop - 150 &&
            scrollPosition < elem.offsetTop + elem.offsetHeight);
    };
    const toggleClasses = (index) => {
        letterButtons.forEach((btn) => {
            btn.classList.remove('bg-primary-color', 'text-white');
        });
        // letterButtons[index].classList.add('bg-primary-color', 'text-white');
    };
    letterButtons.forEach((button, index) => {
        button.addEventListener('click', () => {
            clearTimeout(isScrolling);
            shouldExecuteScrollEvent = false;
            const contentId = button.getAttribute('data-value');
            if (contentId) {
                contentSection = document.getElementById(contentId);
            }
            else {
                const glossaryTitle = button.innerText.trim();
                contentSection = document.getElementById(glossaryTitle);
            }
            if (contentSection) {
                contentSection.scrollIntoView({
                    behavior: 'smooth',
                    inline: 'nearest',
                });
                const header = document.querySelector('.qq__sticky-container');
                if (isMediumScreen() && header) {
                    setTimeout(() => {
                        const headerStyles = getComputedStyle(header);
                        if (headerStyles.position === 'fixed') {
                            // Header is sticky, adjust scrolling
                            const headerHeight = header.offsetHeight;
                            contentSection.scrollIntoView({
                                behavior: 'smooth',
                                block: 'start',
                                inline: 'nearest',
                                offsetTop: -headerHeight,
                            });
                        }
                    }, 500);
                }
                toggleClasses(index);
            }
            isScrolling = setTimeout(() => {
                shouldExecuteScrollEvent = true;
            }, 1000);
        });
    });
    const contentSections = document.querySelectorAll('.content-section');
    function debounce(func, delay) {
        let timeoutId;
        return function () {
            const context = this;
            const args = arguments;
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func.apply(context, args);
            }, delay);
        };
    }
    function scrollAction() {
        if (shouldExecuteScrollEvent) {
            contentSections.forEach((section, index) => {
                if (isElementInView(section)) {
                    currentIndex = index;
                }
            });
            if (currentIndex < contentSections.length - 1) {
                lastIndex = false;
                toggleClasses(currentIndex);
            }
            if (currentIndex == contentSections.length - 1 && !lastIndex) {
                toggleClasses(currentIndex);
                lastIndex = true;
            }
        }
    }
    const debouncedScrollAction = debounce(scrollAction, 10);
    window.addEventListener('scroll', debouncedScrollAction);
    scrollAction();
};
